import * as React from "react";
import { useHistory } from "react-router-dom";

import { PublishedRelease } from "../../../../../../../common/types/release/published-release";

import List from "@material-ui/core/List";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";
import { useLocation, useParams } from "react-router";
import { routes } from "../../../../routes";
import { getTrackFullTitle } from "../../../../utils/get-track-full-title";
import { IngestionMessage } from "../../../../../../../services/publisher-notifications/types/ingestion-message";
import { ReleaseChangelog } from "../../../../../../../services/release-admin/types/release-changelog";
import { ReleaseNote } from "../../../../../../../services/release-admin/types/release-note";

interface ReleaseDetailNavigationProps {
  published: PublishedRelease;
  messages: IngestionMessage[];
  changelog: ReleaseChangelog[];
  notes: ReleaseNote[];
}

export const ReleaseDetailNavigation: React.FC<ReleaseDetailNavigationProps> = (
  props
) => {
  const history = useHistory();
  const location = useLocation();

  const { id } = useParams<{ id: string }>();
  const [selected, setSelected] = React.useState<string>("");

  const { release, tracks } = props.published;
  const basePath = `${routes.releases.list}/${id}`;

  return (
    <nav>
      <List
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            <TitleContainer>{release.title}</TitleContainer>
            {(release.status === "published" ||
              release.status === "pending-processing" ||
              release.backofficeStatus === "accepted") &&
              release.traclink && (
                <URLContainer onClick={() => window.open(release.traclink)}>
                  {release.traclink}
                </URLContainer>
              )}
          </ListSubheader>
        }
      >
        <MenuItem
          selected={selected === routes.releases.generalData}
          button={true}
          divider
          onClick={() => {
            history.push(
              `${basePath}/${routes.releases.generalData}`,
              location.state
            );
            setSelected(routes.releases.generalData);
          }}
        >
          <ListItemText id="some-id" primary="General" />
        </MenuItem>
        <Divider />
        {tracks
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((track) => (
            <MenuItem
              selected={selected === track.id}
              key={track.id}
              button={true}
              divider
              onClick={() => {
                history.push(`${basePath}/track/${track.id}`, location.state);
                setSelected(track.id);
              }}
            >
              <ListItemText id="some-id" primary={getTrackFullTitle(track)} />
            </MenuItem>
          ))}
        {props.messages.length ? (
          <MenuItem
            selected={selected === routes.releases.messages}
            button={true}
            divider
            onClick={() => {
              history.push(
                `${basePath}/${routes.releases.messages}`,
                location.state
              );
              setSelected(routes.releases.messages);
            }}
          >
            <ListItemText id="some-id" primary="FUGA Messages" />
          </MenuItem>
        ) : null}
        {props.changelog.length ? (
          <MenuItem
            selected={selected === routes.releases.changelog}
            button={true}
            divider
            onClick={() => {
              history.push(
                `${basePath}/${routes.releases.changelog}`,
                location.state
              );
              setSelected(routes.releases.changelog);
            }}
          >
            <ListItemText id="some-id" primary="Changelog" />
          </MenuItem>
        ) : null}
        <MenuItem
          selected={selected === routes.releases.notes}
          button={true}
          divider
          onClick={() => {
            history.push(
              `${basePath}/${routes.releases.notes}`,
              location.state
            );
            setSelected(routes.releases.notes);
          }}
        >
          <ListItemText
            id="some-id"
            primary={
              <Typography>
                Notes{" "}
                {props.notes.length ? (
                  <Chip
                    size="small"
                    style={{ marginLeft: "1rem" }}
                    label={`${props.notes.length}`}
                  />
                ) : null}
              </Typography>
            }
          />
        </MenuItem>
      </List>
    </nav>
  );
};

const TitleContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const URLContainer = styled.div`
  overflow: scroll;
  white-space: nowrap;
  cursor: pointer;
`;
